module.exports = __webpack_public_path__ + "img/bgc.af02916b.png";